import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

import { url } from "src/app/config/config";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class FormManagerService {
  private myUrl = url + "form_manager/";

  constructor(private http: HttpClient) {}

  addColumnToTable(columnData: any) {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");
    return this.http
      .post(`${this.myUrl}addColumnToTable.php`, columnData, { headers: headers })
      .pipe(
        map((resp) => {
          return resp;  
        })
      );
  }

  editColumnInTable(columnData: any) {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");
  
    return this.http
      .post(`${this.myUrl}editColumnInTable.php`, columnData, { headers: headers })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  deleteColumnFromTable(columnData: any) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
  
    return this.http
      .post(`${this.myUrl}deleteColumnFromTable.php`, columnData, { headers: headers })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  updateColumnOrder(columnsData: any){
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })

    return this.http
      .post(`${this.myUrl}updateColumnOrder.php`, columnsData, { headers: headers})
      .pipe(
        map((resp) => {
          return resp
        })
      )
  }

}
